import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "contactUsPage" && !(_id in path('drafts.**'))][0]{
  content,
  ogImage,
  seoTitle,
  seoDescription,
  lead
  }`;
}
